import { render, staticRenderFns } from "./TradeStatus.vue?vue&type=template&id=64fc59ef&scoped=true"
import script from "./TradeStatus.vue?vue&type=script&lang=ts"
export * from "./TradeStatus.vue?vue&type=script&lang=ts"
import style0 from "./TradeStatus.vue?vue&type=style&index=0&id=64fc59ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fc59ef",
  null
  
)

export default component.exports